import type {
  CalculatorOption,
  LeasingPeriodGroup,
  LeasingRvOption,
  RentPeriodGroup
} from "../types/calculatorData";

export interface ActiveRentSelection {
  period: CalculatorOption;
  ow: CalculatorOption;
  mileage: CalculatorOption;
}

export interface ActiveLeasingSelection {
  period: CalculatorOption;
  ow: CalculatorOption;
  rv: LeasingRvOption;
}

/** Finds rent period, OW, and mileage marked with `Status: true` in the calculator tree. */
export function getActiveRentSelectionFromTree(
  rentPeriods: RentPeriodGroup[]
): ActiveRentSelection | null {
  const periodGroup = rentPeriods.find((item) => item.Period.Status);
  const owGroup = periodGroup?.Ows.find((item) => item.Ow.Status);
  const mileage = owGroup?.Mileages.find((item) => item.Status);

  if (!periodGroup || !owGroup || !mileage) {
    return null;
  }

  return { period: periodGroup.Period, ow: owGroup.Ow, mileage };
}

/** Finds leasing period, OW, and RV marked with `Status: true` in the calculator tree. */
export function getActiveLeasingSelectionFromTree(
  leasingPeriods: LeasingPeriodGroup[]
): ActiveLeasingSelection | null {
  const periodGroup = leasingPeriods.find((item) => item.Period.Status);
  const owGroup = periodGroup?.Ows.find((item) => item.Ow.Status);
  const rv = owGroup?.Rvs.find((item) => item.Status);

  if (!periodGroup || !owGroup || !rv) {
    return null;
  }

  return { period: periodGroup.Period, ow: owGroup.Ow, rv };
}
